import { render, staticRenderFns } from "./leuco-qa.vue?vue&type=template&id=4a796c1b&"
import script from "./leuco-qa.vue?vue&type=script&lang=js&"
export * from "./leuco-qa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports